import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>This page is not found 404</h1>
        </div>
    );
};

export default NotFound;